import React, { Component } from 'react'
import { Panel } from 'react-bootstrap'

export default class Collapsible extends Component {

  constructor(props) {
    super(props)

    this.state = {
      open: true
    }
  }

  togglePanel(e) {
    this.setState({ open: !this.state.open })
  }

  render() {
    let arrow = (<li><a className="collapse-link no-print" onClick={ this.togglePanel.bind(this) }><i className={ this.state.open ? 'fa fa-chevron-up no-print' : 'fa fa-chevron-down no-print' }></i></a></li>)

    if (this.props.showArrow == false) {
      arrow = ''
    }

    return (
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>{ this.props.title } <small>{ this.props.subTitle }</small></h2>
              <ul className="nav navbar-right" style={{ cursor: 'pointer' }}>
                { arrow }
              </ul>
              <div className="clearfix"></div>
            </div>
            <Panel collapsible expanded={this.state.open} className="col-md-9 col-sm-9 col-xs-12" style={{ width: "100%", border: "0", padding: "0" }}>
              { this.props.content }
            </Panel>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collapsible.js